var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  staticClass: "flex-1",
                  attrs: {
                    filterable: "",
                    placeholder: _vm.$t("pleaseChoose")
                  },
                  on: { change: _vm.getList },
                  model: {
                    value: _vm.paramsData.is_prod,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "is_prod", $$v)
                    },
                    expression: "paramsData.is_prod"
                  }
                },
                _vm._l(_vm.severlist, function(item) {
                  return _c("el-option", {
                    key: item.label,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reqLoading },
                  on: {
                    click: function() {
                      _vm.list = []
                      _vm.getList(1)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("refresh")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.reqLoading,
              expression: "reqLoading"
            }
          ],
          attrs: { data: _vm.list, border: "" }
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "serverName",
              label: _vm.$t("serverName"),
              "min-width": "160"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "serverID",
              label: _vm.$t("serverId"),
              "min-width": "100"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "merge_to_sid",
              label: _vm.$t("mainServerId"),
              "min-width": "120"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      " " +
                        _vm._s(row.merge_to_sid ? row.merge_to_sid : "/") +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "mainServerName",
              label: _vm.$t("mainServerName"),
              "min-width": "160"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "merge_to_sid",
              label: _vm.$t("isMainServer"),
              "min-width": "120"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          row.merge_to_sid == row.serverID
                            ? _vm.$t("yes")
                            : _vm.$t("no")
                        ) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "merge_to_sid",
              label: _vm.$t("isMergedServer"),
              "min-width": "120"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          row.merge_to_sid === 0
                            ? _vm.$t("no")
                            : row.merge_to_sid === undefined
                            ? "/"
                            : _vm.$t("yes")
                        ) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "areaID",
              label: _vm.$t("serverBelongAreaId"),
              "min-width": "160"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "serverIP",
              label: _vm.$t("serverIpAddress"),
              "min-width": "150"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "serverPort",
              label: _vm.$t("serverPort"),
              "min-width": "130"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "new_tag",
              label: _vm.$t("isNewServer"),
              "min-width": "130"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      " " +
                        _vm._s(row.new_tag ? _vm.$t("yes") : _vm.$t("no")) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "is_recomm",
              label: _vm.$t("recommendServerTag"),
              "min-width": "180"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.recommList.find(function(i) {
                            return i.value == row.is_recomm
                          }).label
                        ) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "config_state",
              label: _vm.$t("configServerStatus"),
              "min-width": "140"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.configState.find(function(i) {
                            return i.value == row.config_state
                          }).label
                        ) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "state",
              label: _vm.$t("currentServerStatus"),
              "min-width": "140"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.configState.find(function(i) {
                            return i.value == row.state
                          }).label
                        ) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "role_count",
              label: _vm.$t("currentServerRegisteredPlayers"),
              "min-width": "190"
            }
          }),
          _c("el-table-column", {
            attrs: { label: _vm.$t("canRegister"), "min-width": "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("el-switch", {
                      attrs: {
                        "active-value": 1,
                        "inactive-value": 2,
                        "active-text": _vm.$t("open"),
                        "inactive-text": _vm.$t("close"),
                        "active-color": "#13ce66"
                      },
                      on: {
                        change: function($event) {
                          return _vm.changeLogin(row)
                        }
                      },
                      model: {
                        value: row.register_flag,
                        callback: function($$v) {
                          _vm.$set(row, "register_flag", $$v)
                        },
                        expression: "row.register_flag"
                      }
                    })
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "push_msg",
              label: _vm.$t("serverPushMessage"),
              "min-width": "190",
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("div", { staticClass: "text-ellipsis-1 " }, [
                      _vm._v(" " + _vm._s(row.push_msg || "/") + " ")
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "openTimeFormat",
              label: _vm.$t("openServerTime"),
              "min-width": "200"
            }
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("operation"),
              "min-width": "160",
              fixed: "right"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("div", { staticClass: "x-c" }, [
                      _c(
                        "div",
                        {
                          staticClass: "controlsBtn",
                          on: {
                            click: function($event) {
                              return _vm.$refs.addserver.open(row)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("modify")))]
                      )
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("addserver", {
        ref: "addserver",
        attrs: { prod: { is_prod: _vm.paramsData.is_prod } },
        on: { update: _vm.getList }
      }),
      _c("modifyingRecords", {
        ref: "modifyingRecords",
        attrs: { prod: { is_prod: _vm.paramsData.is_prod } }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }